import s from "./styles";
import Colors from "assets/Colors";
import { useTranslation } from "react-i18next";
import { secondsToTime } from "helpers/dataHelper";
import { useMemo, useState } from "react";
import ClockSessionsTable from "../../../containers/ClockSessions/ClockSessionsTable";
import ClockInsTable from "../../../containers/ClockSessions/ClockInsTable";

const WorkerDetails = ({
  selectedWorker,
  selectStore,
  loadingAll,
  clockSessions,
  worker,
}) => {
  const { t } = useTranslation();

  const userClockSessions = useMemo(
    () =>
      clockSessions.filter(
        (clockSession) =>
          clockSession.userId === selectedWorker &&
          (!selectStore || clockSession.storeId === selectStore)
      ),
    [clockSessions, selectedWorker, selectStore]
  );

  const addNewClockSession = () => {
    /*
    setEditSession(true);
    setClockSessionInEdit({
      _id: new BSON.ObjectId(),
      userId: selectedWorker,
      storeId: selectStore,
      status: "new",
      type: "in",
      chainId: null,
      sessionStart: new Date(),
      sessionEnd: new Date(),
      sessionDuration: "0",
      creationDatetime: new Date(),
    });
     */
  };

  const [updateEnabled, setUpdateEnabled] = useState(false);
  const [currentSession, setCurrentSession] = useState();

  const workerData = useMemo(() => {
    const pauses = userClockSessions?.reduce((count, item) => {
      if (item.type === "pause") {
        count = count + item.sessionDuration;
      }
      return count;
    }, 0);

    const workedUp = userClockSessions?.reduce((count, item) => {
      count = count + item.sessionDuration;
      return count;
    }, 0);

    const activePercentage =
      workedUp > 0 ? (((workedUp - pauses) / workedUp) * 100).toFixed(2) : 0;

    const pausePercentage =
      workedUp > 0 ? ((pauses / workedUp) * 100).toFixed(2) : 0;

    return {
      pauses: pauses,
      workedUp: workedUp,
      activePercentage: activePercentage,
      pausePercentage: pausePercentage,
    };
  }, [selectedWorker]);

  return (
    <>
      <s.Container>
        <s.containerHeader>
          <s.title>{worker?.fullName || selectedWorker}</s.title>
          <s.buttonsHeader>
            {!updateEnabled ? (
              <>
                {currentSession && (
                  <s.button
                    onClick={() => setCurrentSession(null)}
                    disabled={loadingAll}
                  >
                    {t("actions.return")}
                  </s.button>
                )}
                <s.button
                  type="primary"
                  onClick={() => {
                    setUpdateEnabled(true);
                  }}
                  background={Colors.primary}
                  disabled={loadingAll || userClockSessions?.length === 0}
                >
                  {t("actions.edit")}
                </s.button>
              </>
            ) : currentSession ? (
              <>
                <s.button
                  type="primary"
                  onClick={() => {
                    setUpdateEnabled(!updateEnabled);
                  }}
                  background={Colors.primary}
                  disabled={loadingAll || !currentSession}
                >
                  {updateEnabled ? t("actions.cancel") : t("actions.edit")}
                </s.button>
              </>
            ) : (
              <>
                <s.button
                  disabled={loadingAll}
                  onClick={() => {
                    setUpdateEnabled(false);
                  }}
                >
                  {t("actions.cancel")}
                </s.button>
                <s.button
                  background={Colors.primary}
                  onClick={() => {
                    addNewClockSession();
                  }}
                >
                  {t("actions.new")}
                </s.button>
              </>
            )}
          </s.buttonsHeader>
        </s.containerHeader>

        <div>
          <s.containerHeaderText>
            {userClockSessions?.length > 0 ? (
              <>
                <s.text>
                  <s.circleHeaderText background={Colors.primary} />
                  {t("containers.ClockSessions.active")}{" "}
                  {secondsToTime(workerData.workedUp - workerData.pauses, t)} ({" "}
                  {workerData.activePercentage}%)
                </s.text>
                <s.text>
                  <s.circleHeaderText background={Colors.GREY} />
                  {t("containers.ClockSessions.slow")}{" "}
                  {secondsToTime(workerData.pauses, t)} (
                  {workerData.pausePercentage}
                  %)
                </s.text>
              </>
            ) : (
              <s.text>{t("containers.ClockSessions.noActivity")}</s.text>
            )}
          </s.containerHeaderText>

          <s.containerBar
            style={{
              display: "flex",
              background: Colors.background_soft,
            }}
          >
            <s.barCompleted width={workerData.activePercentage} />
            <s.barRemaining width={workerData.pausePercentage} />
          </s.containerBar>
        </div>
      </s.Container>
      {!currentSession && (
        <ClockSessionsTable
          userClockSessions={userClockSessions}
          updateEnabled={updateEnabled}
          setCurrentSession={setCurrentSession}
          selectStore={selectStore}
        />
      )}
      {currentSession && (
        <ClockInsTable
          updateEnabled={updateEnabled}
          clockSession={currentSession}
          selectStore={selectStore}
        />
      )}
    </>
  );
};

export default WorkerDetails;
